function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { flatMap, keyBy } from "lodash";
import determineBlackOrWhiteTextColor from "./determineBlackOrWhiteTextColor";
export function getTagsAndTagOptions(allTags) {
  return flatMap(allTags, function (tag) {
    if (tag.tagOptions && tag.tagOptions.length) {
      return tag.tagOptions.map(function (tagO) {
        var fullname = tag.name + ": " + tagO.name;
        var value = tag.id + ":" + tagO.id;
        return _extends({}, tagO, {
          label: fullname,
          value: value,
          id: tagO.id
        });
      });
    }

    return _extends({}, tag, {
      label: tag.name,
      value: tag.id
    });
  });
}
export function getKeyedTagsAndTagOptions(tags) {
  return keyBy(getTagsAndTagOptions(tags), "value");
}
export function getTagColorStyle(color) {
  return color ? {
    style: {
      backgroundColor: color,
      color: determineBlackOrWhiteTextColor(color)
    }
  } : {};
}
export function getTagProps(vals) {
  return _extends({}, getTagColorStyle(vals.color), {
    children: vals.label || vals.name
  });
}